export default __webpack_public_path__ + "static/media/sailec-regular.6f5920b6.otf";